
import { ScheduleItem } from '@/integrations/supabase/client';

export const panels: ScheduleItem[] = [
  {
    id: "8",
    day: "day1",
    start_time: "11:30",
    end_time: "12:30",
    title: "Panel: Exploring Emerging AI Market Trends",
    description: "Moderator: Philip Hooker, Chief Operating Officer (COO), CUMULOCITY\n\nPanelists:\n- David Groves, Strategic AI Lead & Principal Data Scientist - AI & Analytics, IBM\n- Dr Philip Gaffney, CEO, Camgenium\n- Oliver King-Smith, CEO, SMARTR.AI\n- Tejas Joshi, CTO Data Platform & AI, Oracle",
    location: "Main Hall",
    type: "Panel",
    speaker: null
  }
];
